/**
 * ホームのエージェントタブを出すか。
 * 本番ビルド（vite --mode production / eq-board）では出さない。
 * development / staging ではプランに関係なく出す。
 * NCG 管理者かどうかは呼び出し側が決める。
 */
export function isAgentTabVisible(mode: string = import.meta.env.MODE): boolean {
  return mode !== 'production';
}

export type WorkspaceHomeLanding = 'agent' | 'dashboard' | 'pages';

/**
 * ワークスペースを開いたときの初期画面。
 * エージェントタブがある NCG 管理者はエージェント。
 * タブが無い NCG 管理者はダッシュボード。
 * それ以外はページ一覧。
 */
export function resolveWorkspaceHomeLanding(input: {
  mode?: string;
  isAdmin: boolean;
  isNcg: boolean;
}): WorkspaceHomeLanding {
  if (!input.isAdmin || !input.isNcg) return 'pages';
  return isAgentTabVisible(input.mode) ? 'agent' : 'dashboard';
}
